const currencyFormatter = new Intl.NumberFormat('en-US', {
    // style: 'currency',
    // currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

export const MonthlyRentReportHeader = [
    { field: 'id', headerName: '#', width: 90, headerClassName: 'super-app-theme--header', groupable: false, aggregable: true },
    { field: 'muaji', headerName: 'Muaji', width: 240, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'trs', headerName: 'Transaksione', width: 240, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    // { field: 'client', headerName: 'Furnitori', width: 210, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    {
        field: 'neto', headerName: 'Qiraja Neto', type: 'string', width: 240, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'tax', headerName: 'Tatimi ne Qira', type: 'string', width: 240, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'bruto', headerName: 'Qiraja Bruto', type: 'string', width: 240, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
]

